import { render, staticRenderFns } from "./GrantAchievement.vue?vue&type=template&id=13ddc2b8&scoped=true&"
import script from "./GrantAchievement.vue?vue&type=script&lang=js&"
export * from "./GrantAchievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ddc2b8",
  null
  
)

export default component.exports